import React, { type FC } from 'react';

import { useTranslation } from 'app/lang';

import { PersonalWidget } from '../PersonalWidget';
import { UserCashback } from './components/UserCashback';
import { UserName } from './components/UserName';
import { UserPhone } from './components/UserPhone';

import dictionary from './AccountInformation.dictionary.json';

import styles from './AccountInformation.module.scss';

export const AccountInformation: FC = () => {
  const { t } = useTranslation();

  return (
    <PersonalWidget title={t(dictionary.title)}>
      <div className={styles.container}>
        <UserPhone />
        <UserName />
      </div>
      <UserCashback />
    </PersonalWidget>
  );
};
